import React from 'react';
import PropTypes from 'prop-types';
import { Navigate, useLocation } from 'react-router';

import NoBackofficeAccessPage from '../../pages/NoBackofficeAccessPage';
import { useAppGlobals } from '../../contexts/AppContext';

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const { backofficeAccess, loadingUser, user } = useAppGlobals();

  if (!backofficeAccess) {
    return <NoBackofficeAccessPage />;
  }

  if (!loadingUser) {
    if (user) {
      return children;
    }
    return (
      <Navigate
        to={`/login?redirect=${encodeURIComponent(location.pathname)}`}
        replace
      />
    );
  }

  return null;
};

ProtectedRoute.propTypes = {
  children: PropTypes.node,
};
export default ProtectedRoute;
